// Тексты и настройки витрины магазина — правятся здесь, без поиска по компонентам.
// ⚠ Проверьте формулировки про доставку, поддержку и гарантию: они должны совпадать с вашими условиями.
export const SHOP_CONTENT = {
    brand: { name: '', tagline: 'Запчасти и аксессуары' },
    heroImage: '/assets/shop/BMW-OEM-parts.webp', // положите файл в public/assets/shop/
    hero: {
        badge: 'Гарантия качества OEM',
        title: 'Оригинальные запчасти для вашего авто и мотоцикла',
        accent: '',
        text: 'Оригинальные детали от производителя: от компонентов двигателя до кузовных элементов.',
        cta: 'Перейти в каталог',
        note: 'Подбор по артикулу и модели',
    },
    features: [
        { icon: 'shield', title: 'Оригинальное качество', text: 'Сертифицированные запчасти' },
        { icon: 'truck', title: 'Быстрая доставка', text: 'Самовывоз или доставка' },
        { icon: 'clock', title: 'Поддержка', text: 'Поможем подобрать деталь' },
        { icon: 'wrench', title: 'Гарантия', text: 'На оригинальные запчасти' },
    ],
    productTiles: [
        { icon: 'shield', label: 'Качество OEM' },
        { icon: 'truck', label: 'Быстрая отправка' },
        { icon: 'wrench', label: 'Возврат по условиям магазина' },
    ],
};

// Разделы каталога. Ключ = значение product_type на бэкенде (part | accessory).
export const SHOP_SECTIONS = {
    part: {
        base: '/shop',
        baseLabel: 'Каталог',
        seoTitle: 'Запчасти для авто и мотоциклов | PREMIUM AUTO',
        seoDesc: 'Каталог оригинальных и аналоговых запчастей для автомобилей и мотоциклов. Подбор по артикулу и модели.',
        heading: 'Каталог запчастей',
        allLabel: 'Все запчасти',
        relatedTitle: 'Похожие запчасти',
        placeholder: 'Название, артикул, модель…',
        heroImage: SHOP_CONTENT.heroImage,
        hero: SHOP_CONTENT.hero,
        features: SHOP_CONTENT.features,
    },
    accessory: {
        base: '/shop/accessories',
        baseLabel: 'Аксессуары',
        seoTitle: 'Аксессуары для авто и мотоциклов | PREMIUM AUTO',
        seoDesc: 'Аксессуары для автомобилей и мотоциклов: защита, багаж, электроника, экипировка.',
        heading: 'Каталог аксессуаров',
        allLabel: 'Все аксессуары',
        relatedTitle: 'Похожие аксессуары',
        placeholder: 'Название, артикул, модель…',
        heroImage: '/assets/shop/bmw-accessories2.avif', // положите файл в public/assets/shop/
        hero: {
            badge: 'Аксессуары и экипировка',
            title: 'Аксессуары для вашего авто и мотоцикла',
            accent: '',
            text: 'Защита, багаж, электроника и комфорт: всё, чтобы довести технику до идеала.',
            cta: 'Перейти в каталог',
            note: 'Подбор по модели',
        },
        features: SHOP_CONTENT.features,
    },
};